<fui-key id="{{key}}-key" (key)="add(key)" *ngFor="let key of keys" [title]="key"></fui-key>
<fui-key id="backspace-key" (key)="backspace()">
    <fui-icon [height]="15" [icon]="'backspace'" [width]="30"></fui-icon>
</fui-key>
